// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__1w6zN","list":"PatternAutocomplete_list__1BLwl"};